<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>抵扣标记</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-date-picker
					type="date"
					placeholder="票据开始日期"
					v-model="query.timeStart"
					value-format="yyyy-MM-dd"
				></el-date-picker>&nbsp;
				<el-date-picker
					type="date"
					placeholder="票据结束日期"
					v-model="query.timeEnd"
					value-format="yyyy-MM-dd"
				></el-date-picker>&nbsp;
				<el-select v-model="query.deduction" placeholder="请选择是否抵扣">
					<el-option key="" label="请选择是否抵扣" value=""></el-option>
					<el-option key="false" label="未抵扣" value="false"></el-option>
					<el-option key="true" label="已抵扣" value="true"></el-option>
				</el-select>&nbsp;
				<el-date-picker
					type="month"
					placeholder="抵扣期号"
					v-model="query.deductionPeriod"
					value-format="yyyy-MM"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;
				<a href="https://img.zelixin.cn/template/抵扣导入模板.xlsx" style="font-size:12px;color:#66b1ff">抵扣模板</a>
            </div>
			<el-tabs v-model="activeName" type="card">	
				<el-tab-pane label="抵扣记录" name="deductionTab">
					<el-table
						:data="deductionData"
						border
						class="table"
						ref="deductionData"
						header-cell-class-name="table-header"
						:cell-style="{padding:8+'px'}"
						stripe
					>
						<el-table-column prop="period" label="期号"></el-table-column>
						<el-table-column prop="amount" label="金额"></el-table-column>
						<el-table-column prop="checkTime" label="抵扣时间"></el-table-column>
						<el-table-column prop="createTime" label="创建时间"></el-table-column>
					</el-table>
					<div class="record-a-d">
						<el-button
							style="float:left"
							type="primary"
							icon="el-icon-plus"
							class="handle-del mr10"
							@click="handleAddDeductionRecord"
							v-if="controll['add']"
						>添加抵扣记录</el-button>
						<el-upload
							style="float:left"
							class="upload-demo mr10"
							accept=".xls,.xlsx"
							action= "/blob/deduction/import-excel"
							:on-success="uploadSuccess"
							:file-list="fileList"
							:show-file-list = "false"
							v-if="controll['import']"
							list-type="picture">
							<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入抵扣记录</el-button>
						</el-upload>
					</div>
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="query.deductionPageNum"
							:page-size="query.deductionPageSize"
							:total="deductionPageTotal"
							@current-change="handleDeductionPageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
				
				<el-tab-pane label="进项票" name="incomeTab">
					<el-table
						:data="incomeData"
						border
						class="table"
						ref="incomeMultipleTable"
						header-cell-class-name="table-header"
						@selection-change="handleIncomeSelectionChange"
						:cell-style="{padding:8+'px'}"
						stripe
					>
						<el-table-column type="selection" width="55" align="center" :selectable="isSelectableIncome"></el-table-column>
						<el-table-column prop="channelName" label="公司名称"></el-table-column>
						<el-table-column prop="invoiceCode" label="发票编码" width="120"></el-table-column>
						<el-table-column prop="invoiceNo" label="发票号" width="200"></el-table-column>
						<el-table-column prop="invoiceAccount" label="未税金额" width="100"></el-table-column>
						<el-table-column prop="invoiceAccountTax" label="含税金额" width="100"></el-table-column>
						<el-table-column prop="invoiceDate" label="开票日期" width="120"></el-table-column>
						<el-table-column prop="deductionPeriod" label="抵扣期号" width="120">
							<template slot-scope="scope">
								{{scope.row.deduction?scope.row.deductionPeriod:"未抵扣"}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="140" align="center">
							<template slot-scope="scope">
								<el-button
									type="text"
									icon="el-icon-edit"
									@click="incomeCancelDeduction(scope.$index, scope.row)"
									v-if="controll['cancel'] && scope.row.deduction"
								>撤销抵扣</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="record-a-d">
						<el-button
							style="float:left"
							type="primary"
							icon="el-icon-s-ticket"
							class="handle-del mr10"
							@click="handleIncomeDeduction"
							v-if="controll['sign']"
						>标记抵扣</el-button>
						<el-upload
							style="float:left"
							class="upload-demo mr10"
							accept=".xls,.xlsx"
							action= "/blob/deduction/import-excel"
							:on-success="uploadSuccess"
							:file-list="fileList"
							:show-file-list = "false"
							v-if="controll['import']"
							list-type="picture">
							<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入抵扣记录</el-button>
						</el-upload>
					</div>
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="query.incomePageNum"
							:page-size="query.incomePageSize"
							:total="incomePageTotal"
							@current-change="handleIncomePageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
				
				<el-tab-pane label="成本票" name="costTab">
					<el-table
						:data="costData"
						border
						class="table"
						ref="costMultipleTable"
						header-cell-class-name="table-header"
						@selection-change="handleCostSelectionChange"
						:cell-style="{padding:8+'px'}"
						stripe
					>
						<el-table-column type="selection" width="55" align="center" :selectable="isSelectableCost"></el-table-column>
						<el-table-column prop="drawer" label="开具公司"></el-table-column>
						<el-table-column prop="costNo" label="票据编号" width="200px;"></el-table-column>
						<el-table-column prop="amount" label="金额" width="105px;">
							<template slot-scope="scope">
								￥{{(scope.row.amount + scope.row.taxAmount).toFixed(2)}}
							</template>
						</el-table-column>
						<el-table-column prop="issuingTime" label="开具日期" width="160px;"></el-table-column>
						<el-table-column prop="deductionPeriod" label="抵扣期号" width="120">
							<template slot-scope="scope">
								{{scope.row.deduction?scope.row.deductionPeriod:"未抵扣"}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="140" align="center">
							<template slot-scope="scope">
								<el-button
									type="text"
									icon="el-icon-edit"
									@click="costCancelDeduction(scope.$index, scope.row)"
									v-if="controll['cancel'] && scope.row.deduction"
								>撤销抵扣</el-button>
							</template>
						</el-table-column>
					</el-table>
			
					<div class="record-a-d">
						<el-button
							style="float:left"
							type="primary"
							icon="el-icon-s-ticket"
							class="handle-del mr10"
							@click="handleCostDeduction"
							v-if="controll['sign']"
						>标记抵扣</el-button>
						<el-upload
							style="float:left"
							class="upload-demo mr10"
							accept=".xls,.xlsx"
							action= "/blob/deduction/import-excel"
							:on-success="uploadSuccess"
							:file-list="fileList"
							:show-file-list = "false"
							v-if="controll['import']"
							list-type="picture">
							<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入抵扣记录</el-button>
						</el-upload>
					</div>
					<div class="pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:current-page="query.costPageNum"
							:page-size="query.costPageSize"
							:total="costPageTotal"
							@current-change="handleCostPageChange"
						></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
        </div>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="抵扣信息" :visible.sync="deductionVisible" width="30%">
            <el-form ref="deductionForm" :model="deductionForm" label-width="90px" :rules="deductionRules">
				<el-form-item label="抵扣期号" prop="deductionPeriod">
					<el-date-picker
						type="month"
						placeholder="请选择抵扣期号"
						v-model="deductionForm.deductionPeriod"
						value-format="yyyy-MM"
						style="width:180px;"
					></el-date-picker>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deductionVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveDeduction" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
			
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
			<el-form ref="previewData" :model="previewData" label-width="150px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="税款所属期：">
							{{previewData.period}}
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item label="纳税人名称：">
							{{previewData.name}}
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item label="纳税人识别号：">
							{{previewData.taxNo}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
            <el-table
                :data="previewDetail"
                border
                class="table"
                ref="previewTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				row-key="id"
				stripe
				height="600px"
            >
                <el-table-column prop="no" label="发票号码" width="220">
					<template slot-scope="scope">
						{{scope.row.no?scope.row.no:(scope.row.invoiceCode?(scope.row.invoiceCode + "-" + scope.row.invoiceNo):"")}}
					</template>
				</el-table-column>
				<el-table-column prop="companyName" label="销方名称"></el-table-column>
				<el-table-column prop="operateDate" label="开票日期" width="160"></el-table-column>
				<el-table-column prop="amountWithoutTax" label="未税金额" width="100"></el-table-column>
				<el-table-column prop="tax" label="税额" width="100"></el-table-column>
				<el-table-column prop="incomeType" label="发票票种" width="150"></el-table-column>
				<el-table-column prop="checkTime" label="勾选时间" width="160"></el-table-column>
				<el-table-column prop="status" label="发票状态"></el-table-column>
            </el-table>
			<span slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveDeduction2" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="抵扣记录" :visible.sync="deductionRecordVisible" width="30%">
            <el-form ref="deductionRecordForm" :model="deductionRecordForm" label-width="90px" :rules="deductionRecordRules">
				<el-form-item label="抵扣期号" prop="period">
					<el-date-picker
						type="month"
						placeholder="请选择抵扣期号"
						v-model="deductionRecordForm.period"
						value-format="yyyy-MM"
						style="width:180px;"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="抵扣金额" prop="amount">
					<el-input v-model="deductionRecordForm.amount" placeholder="请输入抵扣金额"></el-input>
				</el-form-item>
				<el-form-item label="抵扣日期" prop="checkTime">
					<el-date-picker
						type="date"
						placeholder="请选择抵扣日期"
						v-model="deductionRecordForm.checkTime"
						value-format="yyyy-MM-dd"
						style="width:180px;"
					></el-date-picker>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deductionRecordVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveDeductionRecord" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getTime, checkAmount } from '../../../utils/common';
import { getControll } from '../../../utils/controlls';
import { fetchDeductionData, deductionIncome, deductionCost, cancelDeductionIncome, cancelDeductionCost, 
deductionByUuid, saveDeductionRecord } from '../../../api/index';
export default {
    name: 'deduction',
    data() {
        return {
            query: {
                incomePageNum: 1,
                incomePageSize: 10,
				costPageNum: 1,
                costPageSize: 10,
				deductionPageNum: 1,
                deductionPageSize: 10
            },
            incomeData: [],
			costData:[],
            multipleIncomeSelection: [],
			multipleCostSelection:[],
            incomePageTotal: 0,
			costPageTotal: 0,
			deductionPageTotal: 0,
			deductionRules:{
				deductionPeriod:[{ required: true, message: '抵扣期号不能为空', trigger: 'blur' }]
			},
			deductionRecordRules:{
				period:[{ required: true, message: '请选择抵扣期号', trigger: 'blur' }],
				amount:[{ required: true, validator:checkAmount, trigger: 'blur' }],
				checkTime:[{ required: true, message: '请选择抵扣时间', trigger: 'blur' }],
			},
			deductionType:"",
			deductionForm:{},
			deductionVisible:false,
			controll:{},
			previewData:{},
			previewDetail:[],
			activeName:"deductionTab",
			previewVisible:false,
			fileList:[],
			deductionRecordForm:{},
			deductionRecordVisible:false,
			deductionData:[]
		}
	},
    created() {
		this.controll = getControll("deduction");
        this.getData();
    },
    methods: {
        // 获取数据
        getData() {
            fetchDeductionData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.incomeData = res.data.incomePager.records;
					this.incomePageTotal = res.data.incomePager.total;
					this.costData = res.data.costPager.records;
					this.costPageTotal = res.data.costPager.total;
					this.deductionData = res.data.deductionPager.records;
					this.deductionPageTotal = res.data.deductionPager.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'incomePageNum', 1);
			this.$set(this.query, 'costPageNum', 1);
			this.$set(this.query, 'deductionPageNum', 1);
            this.getData();
        },
        // 多选操作
        handleIncomeSelectionChange(val) {
            this.multipleIncomeSelection = val;
        },
		handleCostSelectionChange(val) {
			this.multipleCostSelection = val;
		},
        // 分页导航
        handleIncomePageChange(val) {
            this.$set(this.query, 'incomePageNum', val);
            this.getData();
        },
		// 分页导航
        handleCostPageChange(val) {
            this.$set(this.query, 'costPageNum', val);
            this.getData();
        },
		handleDeductionPageChange(val) {
			this.$set(this.query, 'deductionPageNum', val);
            this.getData();
		},
		handleIncomeDeduction() {
			this.openDeductionDialog(0, this.multipleIncomeSelection);
		},
		handleCostDeduction() {
			this.openDeductionDialog(1, this.multipleCostSelection);
		},
		isSelectableIncome(row, index) {
			return !row.deduction;
		},
		isSelectableCost(row, index) {
			return !row.deduction;
		},
		//打开抵扣对话框
		openDeductionDialog(deductionType, selection) {
			this.deductionForm = {};
			this.deductionType = deductionType;
			const length = selection.length;
			if (length == 0) {
				this.$message.error(`请选择要标记抵扣的` + (deductionType==0?`进项票`:`成本票`) + `！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(selection[i].id)
            }
			this.deductionForm["ids"] = ids;
			this.deductionVisible = true;
		},
		saveDeduction() {
			this.$refs.deductionForm.validate(valid => {
				if (valid) {
					let method = this.deductionType == 0?deductionIncome:deductionCost;
					method(this.deductionForm).then(res => {
						if (res.code == 0) {
							this.$message.success('标记成功！');
							this.deductionVisible = false;
							this.getData();
						} else {
							this.$message.error(`标记失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		incomeCancelDeduction(index, row) {
			this.cancelDeduction(row.id, 0);
		},
		costCancelDeduction(index, row) {
			this.cancelDeduction(row.id, 1);
		},
		saveDeduction2() {
			this.$confirm('确定执行抵扣吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let param = {};
					param["uuid"] = this.uuid;
					param["deductionPeriod"] = this.previewData["period"];
					deductionByUuid(param).then(res => {
						if (res.code == 0) {
							if (res.data == undefined || res.data == null){
								this.$message.success('抵扣成功');
								this.previewVisible = false;
								this.getData();
							} else {
								this.$message.error('抵扣执行失败，部分抵扣数据不存在！');
								this.previewDetail = res.data.obj;
							}
						} else {
							this.$message.error(`抵扣失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		cancelDeduction(id, type) {
			this.$confirm('确定要撤销选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let method = (type == 0?cancelDeductionIncome:cancelDeductionCost);
					method(id).then(res => {
						if (res.code == 0) {
							this.$message.success('撤销成功！');
							this.getData();
						} else {
							this.$message.error(`撤销失败！` + res.message);
						}
					})
				})
				.catch(() => {});
		},
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.data;
				this.previewDetail = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		handleAddDeductionRecord() {
			this.deductionRecordForm = {};
			this.deductionRecordVisible = true;
		},
		handleSaveDeductionRecord() {
			this.$refs.deductionRecordForm.validate(valid => {
				if (valid) {
					this.$set(this.deductionRecordForm, "checkTime", this.deductionRecordForm["checkTime"] + " 00:00:00");
					saveDeductionRecord(this.deductionRecordForm).then(res => {
						if (res.code == 0) {
							this.$message.success('添加成功！');
							this.deductionRecordVisible = false;
							this.getData();
						} else {
							this.$message.error(`添加失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
